
import { Box, Center } from '@chakra-ui/react'

import React from 'react';

const NotFound = () => {
  return (
    <Box>
    <Center>
      <h2>404 Not Found</h2>
      <p>Sorry, the page you are looking for does not exist.</p>
      </Center>
    </Box>

  );
};

export default NotFound;
